<section class="optional-note" [class.optional-note--inline]="variant === 'inline'">
  @if (iconOnly) {
    <button
      type="button"
      class="optional-note__trigger"
      [class.optional-note__trigger--icon]="iconOnly"
      [class.is-active]="isActive"
      [attr.aria-label]="buttonLabel"
      [title]="buttonLabel"
      (click)="toggle()"
    >
      <i [class]="iconClass" aria-hidden="true"></i>
    </button>
    @if (expanded) {
      <div class="optional-note__inline">
        <div class="optional-note__head">
          <small>{{ label }}</small>
          <button type="button" class="optional-note__clear" (click)="clear()">
            Quitar
          </button>
        </div>
        <textarea
          [rows]="rows"
          [value]="value"
          [placeholder]="placeholder"
          (input)="onInput($event)"
        ></textarea>
      </div>
    }
  } @else {
    @if (!expanded) {
      <button
        type="button"
        class="optional-note__trigger"
        [attr.aria-label]="buttonLabel"
        [title]="buttonLabel"
        (click)="open()"
      >
        + {{ buttonLabel }}
      </button>
    } @else {
      <div class="optional-note__head">
        <small>{{ label }}</small>
        <button type="button" class="optional-note__clear" (click)="clear()">
          Quitar
        </button>
      </div>
      <textarea
        [rows]="rows"
        [value]="value"
        [placeholder]="placeholder"
        (input)="onInput($event)"
      ></textarea>
    }
  }
</section>
